import React, { useState, useEffect } from 'react';
import './IOSPopup.css';

const IOSPopup = ({ onClose }) => {
    var uuid = localStorage.getItem("web_uuid")
    function sendEventLog(eventName) {
        var localParams = new Map(Object.entries(JSON.parse(localStorage.getItem("params"))));

        var body = {};
        body["action"] = eventName;
        body["uuid"] = uuid;
        body["first"] = localStorage.getItem("appInstalled") == null;
        body["host"] = window.location.host;
        body["os"] = "ios";
        localParams.forEach((value, key) => {
            body[key] = value;
        });

        var content = JSON.stringify(body)
        console.log("sendEventLog: " + content);
        var xhr = new XMLHttpRequest();
        var url = "https://log.cashrush.cc/log";
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(content);
    }

    function onLoad() {
        sendEventLog("PwaLoad");
        console.log('ios is fully loaded');
    }

    let isLoadListenerAdded = false;
    if (!isLoadListenerAdded) {
        console.log("document.readyState: " + document.readyState);
        if (document.readyState === 'complete') {
            onLoad();
        } else {
            window.addEventListener('load', onLoad);
        }
        isLoadListenerAdded = true;
    }

    return (
        <div className="popup-container">
            <div className="popup-content">
                <button className="close-btn" onClick={onClose}>×</button>
                <h2 className="popup-title">Add to Home Screen</h2>
                <ol className="popup-list">
                    <li>
                        1. Click on the button to open the menu, open in external browser.
                        <img src="/image/ios/1.jpg" alt="Step 1" className="step-image" />
                    </li>
                    <li>
                        2. Tap the Share icon at the bottom of the screen.
                        <img src="/image/ios/2.jpg" alt="Step 2" className="step-image" />
                    </li>
                    <li>
                        3. Scroll down to the list of actions and tap Add to Home Screen.
                        <img src="/image/ios/3.jpg" alt="Step 3" className="step-image" />
                    </li>
                    <li>
                        4. Click to add select "Add"
                        <img src="/image/ios/4.jpg" alt="Step 4" className="step-image" />
                    </li>
                </ol>
            </div>
        </div>
    );
};

export default IOSPopup;